import React from 'react'
import './Iconsection.css'
import Circle from '../../../assets/iconsection/circle.png'
import Innercircle1 from "../../../assets/iconsection/1.png"
import Innercircle2 from "../../../assets/iconsection/2.png"
import Innercircle3 from "../../../assets/iconsection/3.png"
import Innercircle4 from "../../../assets/iconsection/4.png"
export default function Iconsection() {
  return (
    <>
        <div class="container-fluid p-0 pt-2">
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 py-5">
            <div class="col d-flex align-items-start justify-content-center">
                <div class="d-flex justify-content-start sizecenter" >
              <div class="circlediv position-relative d-flex justify-content-center align-items-center">
                <img class="circle position-absolute" src={Circle} alt=""/>
                <img class="circle position-absolute size" src={Innercircle1} alt=""/>
              </div>
              <div class="ml">
                <h4 class="fw-bold mb-0 fs-2 mb-2">7,500+</h4>
                <p class="fs-5 grey">Acres of land <br/> (FIEDMC SEZs)</p>
              </div>
              </div>
            </div>
            <div class="col d-flex align-items-start justify-content-center">
                <div class="d-flex justify-content-start sizecenter " >
                <div class="circlediv position-relative d-flex justify-content-center align-items-center">
                  <img class="circle position-absolute" src={Circle} alt=""/>
                  <img class="circle position-absolute size" src={Innercircle2} alt=""/>
                </div>
                <div class="ml">
                  <h4 class="fw-bold mb-0 fs-3 mb-1">7,500+</h4>
                  <p class="fs-5 grey">Jobs Opportunities <br/> (FIEDMC SEZs)</p>
                </div>
            </div>
              </div>
              <div class="col d-flex align-items-start justify-content-center">
                <div class="d-flex justify-content-start sizecenter " >
                <div class="circlediv position-relative d-flex justify-content-center align-items-center">
                  <img class="circle position-absolute" src={Circle} alt=""/>
                  <img class="circle position-absolute size" src={Innercircle3} alt=""/>
                </div>
                <div class="ml">
                  <h4 class="fw-bold mb-0 fs-3 mb-1">7,500+</h4>
                  <p class="fs-5 grey">Investment <br/> (FIEDMC SEZs)</p>
                </div>
            </div>
              </div>
              <div class="col d-flex align-items-start justify-content-center">
                <div class="d-flex justify-content-start sizecenter " >
                <div class="circlediv position-relative d-flex justify-content-center align-items-center">
                  <img class="circle position-absolute" src={Circle} alt=""/>
                  <img class="circle position-absolute size" src={Innercircle4} alt=""/>
                </div>
                <div class="ml">
                  <h4 class="fw-bold mb-0 fs-3 mb-1">7,500+</h4>
                  <p class="fs-5 grey">Industries <br/> (FIEDMC SEZs)</p>
                </div>
            </div>
              </div>
          </div>
    </div>


    </>
  ) 
}
